const getIconSet = require('@lib/getIconSet');

const hash = __webpack_hash__; // eslint-disable-line
const hashFilename = __IS_DEVELOPMENT__ ? `/iconset.svg` : `${__BASEURL__}assets/common/images/svgs/iconset-${hash}.svg`; // eslint-disable-line
getIconSet(hashFilename);
